import React from "react";
import { Nav, NavItem, NavLink } from "reactstrap";

type StockTabId =
  | "resumen"
  | "stock-por-articulo"
  | "stock-por-familia-linea"
  | "stock-por-sucursal"
  | "movimientos-por-fecha";

type StockTabsNavProps = {
  activeTab: StockTabId;
  onChange: (tab: StockTabId) => void;
};

const StockTabsNav = ({
  activeTab,
  onChange,
}: StockTabsNavProps) => (
  <Nav tabs className="mb-3">
    <NavItem>
      <NavLink
        className={activeTab === "resumen" ? "active" : ""}
        href="#"
        onClick={(event) => {
          event.preventDefault();
          onChange("resumen");
        }}
      >
        <i className="ri-dashboard-2-line me-1"></i>
        Resumen
      </NavLink>
    </NavItem>
    <NavItem>
      <NavLink
        className={activeTab === "stock-por-articulo" ? "active" : ""}
        href="#"
        onClick={(event) => {
          event.preventDefault();
          onChange("stock-por-articulo");
        }}
      >
        <i className="ri-inbox-archive-line me-1"></i>
        Control de stock por artículo
      </NavLink>
    </NavItem>
    <NavItem>
      <NavLink
        className={activeTab === "movimientos-por-fecha" ? "active" : ""}
        href="#"
        onClick={(event) => {
          event.preventDefault();
          onChange("movimientos-por-fecha");
        }}
      >
        <i className="ri-calendar-2-line me-1"></i>
        Movimientos por fecha
      </NavLink>
    </NavItem>
  </Nav>
);

export type { StockTabId };
export default StockTabsNav;
